"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.bank2ynab = exports.generateParser = exports.calculateOutflow = exports.calculateInflow = exports.parseNumber = void 0;

require("mdn-polyfills/String.prototype.startsWith");

var papaparse_1 = require("../util/papaparse");

var read_encoded_file_1 = require("../util/read-encoded-file");

var parse_date_1 = require("./parse-date");

var banks_json_1 = __importDefault(require("./banks.json"));

exports.parseNumber = function (input) {
  if (typeof input === 'undefined') {
    return undefined;
  }

  try {
    if (input.includes(',')) {
      return Number(input.replace(',', '.'));
    }

    return Number(input);
  } catch (e) {
    return undefined;
  }
};

exports.calculateInflow = function (inflow, outflow) {
  if (typeof inflow === 'undefined' && typeof outflow === 'undefined') {
    return undefined;
  }

  if (typeof inflow !== 'undefined' && typeof outflow === 'undefined') {
    return inflow < 0 ? undefined : inflow;
  }

  if (typeof inflow === 'undefined' && typeof outflow !== 'undefined') {
    return outflow < 0 ? -outflow : undefined;
  }

  if (typeof inflow !== 'undefined' && typeof outflow !== 'undefined') {
    throw new Error("Inflow and outflow can't be set simultaneously");
  }
};

exports.calculateOutflow = function (inflow, outflow) {
  if (typeof outflow === 'undefined' && typeof inflow === 'undefined') {
    return undefined;
  }

  if (typeof outflow !== 'undefined' && typeof inflow === 'undefined') {
    return outflow < 0 ? undefined : outflow;
  }

  if (typeof outflow === 'undefined' && typeof inflow !== 'undefined') {
    return inflow < 0 ? -inflow : undefined;
  }

  if (typeof outflow !== 'undefined' && typeof inflow !== 'undefined') {
    throw new Error("Inflow and outflow can't be set simultaneously");
  }
};

exports.generateParser = function (config) {
  var columns = config.inputColumns.reduce(function (acc, cur, index) {
    var _a;

    if (cur === 'skip') {
      return acc;
    }

    return __assign(__assign({}, acc), (_a = {}, _a[cur] = index, _a));
  }, {});

  var hasCol = function hasCol(name) {
    return Object.keys(columns).includes(name);
  };

  var match = function match(file) {
    return __awaiter(void 0, void 0, void 0, function () {
      var content, data, match, row;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , read_encoded_file_1.readEncodedFile(file)];

          case 1:
            content = _a.sent();
            return [4
            /*yield*/
            , papaparse_1.parse(content.trim())];

          case 2:
            data = _a.sent().data;
            match = file.name.match(new RegExp(config.filenamePattern));

            if (!match) {
              return [2
              /*return*/
              , false];
            } // Check that enough columns exist


            if (data.length === 0 || data[0].length < config.inputColumns.length) {
              return [2
              /*return*/
              , false];
            }

            row = data.filter(function (d) {
              return d.length > 1;
            })[config.headerRows]; // Check that the date column is set correctly

            try {
              if (!parse_date_1.parseDate(row[columns.Date], config.dateFormat)) {
                return [2
                /*return*/
                , false];
              }
            } catch (e) {
              return [2
              /*return*/
              , false];
            } // Check that the payee column is not a date


            try {
              if (columns.Payee && parse_date_1.parseDate(row[columns.Payee], config.dateFormat)) {
                return [2
                /*return*/
                , false];
              }
            } catch (e) {} // Check that the inflow column is set correctly, if it exists


            if (columns.Inflow && isNaN(exports.parseNumber(row[columns.Inflow]))) {
              return [2
              /*return*/
              , false];
            } // Check that the outflow column is set correctly, if it exists


            if (columns.Outflow && isNaN(exports.parseNumber(row[columns.Outflow]))) {
              return [2
              /*return*/
              , false];
            }

            return [2
            /*return*/
            , true];
        }
      });
    });
  };

  var parse = function parse(file) {
    return __awaiter(void 0, void 0, void 0, function () {
      var content, data, ynabData;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , read_encoded_file_1.readEncodedFile(file)];

          case 1:
            content = _a.sent();
            return [4
            /*yield*/
            , papaparse_1.parse(content.trim())];

          case 2:
            data = _a.sent().data;
            ynabData = data.slice(config.headerRows, data.length - config.footerRows).filter(function (d) {
              return d.length > 1;
            }).map(function (d) {
              return __assign({
                Category: hasCol('Category') ? d[columns.Category] : undefined,
                Payee: hasCol('Payee') ? d[columns.Payee] : undefined,
                Date: hasCol('Date') ? parse_date_1.ynabDate(parse_date_1.parseDate(d[columns.Date], config.dateFormat)) : undefined
              }, config.inflowOutflowFlag && hasCol('CDFlag') ? {
                Inflow: d[columns.CDFlag].trim() === config.inflowOutflowFlag[1] ? exports.parseNumber(d[columns.Inflow]) : undefined,
                Outflow: d[columns.CDFlag].trim() === config.inflowOutflowFlag[2] ? exports.parseNumber(d[columns.Inflow]) : undefined
              } : {
                Inflow: exports.calculateInflow(hasCol('Inflow') ? exports.parseNumber(d[columns.Inflow]) : undefined, hasCol('Outflow') ? exports.parseNumber(d[columns.Outflow]) : undefined),
                Outflow: exports.calculateOutflow(hasCol('Inflow') ? exports.parseNumber(d[columns.Inflow]) : undefined, hasCol('Outflow') ? exports.parseNumber(d[columns.Outflow]) : undefined)
              });
            });
            return [2
            /*return*/
            , [{
              data: ynabData
            }]];
        }
      });
    });
  };

  return {
    name: config.name,
    link: config.link,
    country: config.country,
    filenamePattern: new RegExp(config.filenamePattern),
    fileExtension: config.filenameExtension || 'csv',
    match: match,
    parse: parse
  };
};

var blacklist = ['de N26', 'de ING-DiBa', 'ie N26'];
exports.bank2ynab = banks_json_1["default"].filter(function (b) {
  return !blacklist.includes(b.country + " " + b.name);
}).map(function (bank) {
  return exports.generateParser(bank);
});